import './navigation';
import './ajax-add-to-cart';
import { loadLegacyVue } from './utils/legacy-vue.mjs';

const loadOptionalRuntime = () => loadLegacyVue(document, window.jsData?.legacyVue);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadOptionalRuntime, { once: true });
else loadOptionalRuntime();
